import { render, staticRenderFns } from "./twitterIcon.vue?vue&type=template&id=02864e03&scoped=true"
import script from "./twitterIcon.vue?vue&type=script&lang=js"
export * from "./twitterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02864e03",
  null
  
)

export default component.exports